module.exports = __webpack_public_path__ + "static/media/leadership-image2.b75caaa1.png";